import { Avatar, getInitials } from "src/components/atoms/Avatar/Avatar";
import { useBreakpoint } from "src/components/util/useBreakpoint";
import * as Team from "src/state/modules/team";
import Styles from "./PlayerProfileHeader.module.scss";
import { Text } from "../../../atoms/Text/Text";
import { ProfileLinks } from "src/components/atoms/ProfileLinks/ProfileLinks";
import { isRecruitingAgeGroup } from "src/utils/player-profile-links";

type Props = {
  player: Team.Player;
  sport: Team.Sport;
  team?: Team.Team;
};

export const PlayerProfileHeader = ({ player, sport, team, ...props }: Props) => {
  const breakpoint = useBreakpoint();
  const firstName = player.first_name;
  const lastName = player.last_name;
  const jerseyNumber = player.number || "";
  const bats = player.batting_side || "-";
  const throws = player.throwing_hand || "-";
  const initials = getInitials({ firstName, lastName });

  const playerFormatter = (firstName: string, lastName: string, jerseyNumber: string) => {
    let formattedPlayer = "";

    if (firstName) {
      formattedPlayer += firstName;

      if (lastName) {
        formattedPlayer += ` ${lastName}`;
      }

      if (jerseyNumber) {
        formattedPlayer += `, #${jerseyNumber}`;
      }
      return formattedPlayer;
    }

    if (lastName) {
      formattedPlayer += lastName;

      if (jerseyNumber) {
        formattedPlayer += `, #${jerseyNumber}`;
      }
      return formattedPlayer;
    }

    if (jerseyNumber) {
      formattedPlayer += `#${jerseyNumber}`;
    }

    return formattedPlayer;
  };

  const searchName = `${firstName ?? ""} ${lastName ?? ""}`.trim();
  const showProfileLinks = !!team && isRecruitingAgeGroup(team.ageGroup);

  const avatarSize = breakpoint === "xs" || breakpoint === "sm" ? "medium" : "large";
  const playerProfileBioInfoSize = breakpoint === "xs" || breakpoint === "sm" ? "medium" : "large";
  const playerProfileBioInfoBatsSize = breakpoint === "xs" || breakpoint === "sm" ? "base" : "medium";

  return (
    <div className={Styles.playerProfileHeader}>
      <div className={Styles.playerProfileBio}>
        <Avatar.Person initials={initials} size={avatarSize} className={Styles.playerProfileBioAvatar} />

        <div className={Styles.playerProfileBioInfo}>
          <Text size={playerProfileBioInfoSize} weight={"xbold"} className={Styles.playerProfileBioInfoName}>
            {playerFormatter(firstName, lastName, jerseyNumber.toString())}
          </Text>
          <div className={Styles.playerProfileBioInfoBats}>
            <Text size={playerProfileBioInfoBatsSize}>
              <>Bats: {bats}</>
            </Text>
            <Text size={playerProfileBioInfoBatsSize}>
              <>Throws: {throws}</>
            </Text>
          </div>
          {showProfileLinks && searchName && (
            <ProfileLinks variant="button" name={searchName} state={team?.state} />
          )}
        </div>
      </div>
    </div>
  );
};
